<script>
  import ExpertCard from '../components/ExpertCard.svelte';
  import { expertsSection } from './experts.js';

  const visibleExperts = expertsSection.experts;
</script>

<section id="experts" class="experts-section" aria-labelledby="experts-title">
  <div class="experts-inner">
    <div class="experts-content">
      <div class="experts-head">
        <div class="experts-title-group">
          <p class="experts-kicker">{expertsSection.kicker}</p>
          <div class="experts-heading-wrap">
            <h2 id="experts-title">{expertsSection.title}</h2>
            <div class="section-line" aria-hidden="true"></div>
          </div>
        </div>

        <p class="experts-description">
          {#each expertsSection.description as line}
            <span>{line}</span>
          {/each}
        </p>
      </div>

      <div class="experts-grid" aria-label="Эксперты форума">
        {#each visibleExperts as expert}
          <ExpertCard {...expert} />
        {/each}
      </div>

    </div>
  </div>
</section>

<style>
  .experts-section {
    display: flex;
    justify-content: center;
    padding: 100px 0;
    background: #000000;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .experts-inner {
    display: flex;
    width: min(100%, 1440px);
    align-items: center;
    justify-content: center;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .experts-content {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 48px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .experts-head {
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: 48px;
  }

  .experts-title-group,
  .experts-heading-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .experts-title-group {
    gap: 18px;
  }

  .experts-heading-wrap {
    gap: 21px;
  }

  .experts-kicker,
  h2,
  .experts-description {
    margin: 0;
  }

  .experts-kicker {
    color: #ffa800;
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
  }

  h2 {
    color: #ffffff;
    font-size: 56px;
    font-weight: 700;
    line-height: 56px;
  }

  .section-line {
    display: none;
    width: 78px;
    height: 4px;
    background: #e7b962;
  }

  .experts-description {
    width: 548px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    text-align: right;
  }

  .experts-description span {
    display: block;
  }

  .experts-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
  }


  @media (max-width: 1279px) {
    .experts-inner {
      padding: 0 32px;
    }

    .experts-content {
      padding: 0 12px;
    }

    .experts-head {
      flex-direction: column;
      gap: 24px;
    }

    .experts-title-group,
    .experts-heading-wrap,
    .experts-description {
      width: 100%;
    }

    .section-line {
      display: block;
    }

    .experts-description {
      max-width: 620px;
      text-align: left;
    }

    .experts-grid {
      grid-template-columns: repeat(2, minmax(300px, 1fr));
      align-items: start;
    }

    h2 {
      font-size: 40px;
      line-height: 1.1;
    }

    .experts-description {
      font-size: 18px;
      line-height: 28px;
    }
  }

  @media (max-width: 1599px) and (min-width: 1280px) {
    h2 {
      font-size: 48px;
      line-height: 1.1;
    }

    .experts-description {
      font-size: 20px;
      line-height: 30px;
    }
  }

  @media (max-width: 767px) {
    .experts-section {
      padding: 40px 0;
    }

    .experts-inner {
      padding: 0 24px;
    }

    .experts-content {
      padding: 0;
    }

    h2 {
      font-size: 32px;
      line-height: 32px;
    }

    .experts-kicker {
      font-size: 16px;
      line-height: 16px;
    }

    .experts-description {
      font-size: 18px;
      line-height: 27px;
    }

    .experts-grid {
      grid-template-columns: 1fr;
    }

    .experts-toggle {
      font-size: 14px;
      padding: 12px 24px;
    }
  }
</style>
